export default __webpack_public_path__ + "static/media/Gardens-mint.063464a0.gif";